import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Button } from 'antd';

class AlertTips extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    saveReport: PropTypes.func,
    saveReview: PropTypes.func,
    quitReport: PropTypes.func,
    quitVerify: PropTypes.func,
    refuseReView: PropTypes.func,
    operateName: PropTypes.string,
  };

  state = {
    confirmLoading: false,
    status: 0,
    content: {
      submit: {
        title: '提交报告',
        message: '确认提交报告？提交后将进行审核！',
      },
      review: { title: '提交审核', message: '确认提交审核！' },
      review2: { title: '提交疑难转诊', message: '确认提交疑难转诊！' },
      quitReport: {
        title: '放弃填写',
        message: '是否确认放弃填写此报告，放弃后将由其他医生填写',
      },
      quitVerify: {
        title: '放弃审核',
        message: '是否确认放弃审核此报告，放弃后将由其他医生审核',
      },
      refuseReView: {
        title: '退回重写',
        message:
          '是否确认将此报告退回重写？退回后报告将变成待报告状态，可由其他医生重新填写报告',
      },
      dangerSubmit: {
        title: '危急值提醒',
        message:
          '尊敬的用户，通过AI分析您报告/审核的影像所见和诊断建议内容，需要进行危急值提醒。',
        okText: '确认提醒',
        cancelText: '忽略',
      },
      dangerReview: {
        title: '危急值提醒',
        message:
          '尊敬的用户，通过AI分析您报告/审核的影像所见和诊断建议内容，需要进行危急值提醒。',
        okText: '确认提醒',
        cancelText: '忽略',
      },
      dangerReview2: {
        title: '危急值提醒',
        message:
          '尊敬的用户，通过AI分析您报告/审核的影像所见和诊断建议内容，需要进行危急值提醒。',
        okText: '确认提醒',
        cancelText: '忽略',
      },
    },
    currentOperate: {},
  };

  componentDidUpdate(prevProps) {
    const { visible, operateName } = this.props;
    if (prevProps.visible !== visible && visible) {
      const { content } = this.state;
      this.setState({ currentOperate: content[operateName] });
    }
  }

  handleOk = () => {
    //保存评价内容
    const { operateName } = this.props;

    switch (operateName) {
      case 'submit': //提交报告
        this.props.saveReport(1);
        break;
      case 'review': //提交审核
        this.props.saveReview();
        break;
      case 'review2': //提交疑难转诊(非危急)
        this.props.saveReview(false, true);
        break;
      case 'quitReport': //放弃填写报告
        this.props.quitReport();
        break;
      case 'quitVerify': //放弃审核报告
        this.props.quitVerify();
        break;
      case 'refuseReView': //拒绝报告
        this.props.refuseReView();
        break;
      case 'dangerSubmit': //危急报告
        this.props.saveReport(1, true);
        break;
      case 'dangerReview': //危急审核
        this.props.saveReview(true);
        break;
      case 'dangerReview2': //危急疑难转诊
        this.props.saveReview(true, true);
        break;
      default:
        break;
    }
  };

  //点击“取消按钮”隐藏对话框
  handleCancel = () => {
    const { operateName } = this.props;

    switch (operateName) {
      case 'dangerSubmit':
        this.props.saveReport(1);
        break;
      case 'dangerReview':
        this.props.saveReview();
        break;
      case 'dangerReview2':
        this.props.saveReview(false, true);
        break;
      default:
        break;
    }

    this.props.onCancel(false);
  };

  render() {
    const { confirmLoading, currentOperate } = this.state;
    const { visible } = this.props;
    return (
      <div className="group-modal">
        <Modal
          title={currentOperate.title}
          visible={visible}
          width={600}
          height={240}
          className="group-manager"
          onCancel={this.handleCancel}
          centered={true}
          keyboard={false}
          maskClosable={false}
          footer={[
            <Button
              key="cancel"
              onClick={this.handleCancel}
              type="default"
              className="btn-cancel"
            >
              {currentOperate.cancelText || '取消'}
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={confirmLoading}
              onClick={this.handleOk}
              className="btn-ok"
            >
              {currentOperate.okText || '提交'}
            </Button>,
          ]}
        >
          <div className="report-modal-alert-content">
            <p>{currentOperate.message}</p>
          </div>
        </Modal>
      </div>
    );
  }
}

export default AlertTips;
